<template>
  <div class="container">
    <template v-if="isVolunteerClash">
      {{ message.message }}
      <br />
      {{ formatDateAsDayWithSuffix(message.data.shift?.startDate) }}
      {{ formatTimeHoursMins(message.data.shift?.startDate) }} -
      {{ formatTimeHoursMins(message.data.shift?.endDate) }} clashes with:
    </template>
    <template v-else>
      <h3>{{ assignee }} has shift clashes</h3>
      <p>
        Your last update was saved (
        {{ formatDateAsDayWithSuffix(message.data.shift.startDate) }}
        {{ formatTimeHoursMins(message.data.shift.startDate) }} -
        {{ formatTimeHoursMins(message.data.shift.endDate) }}
        ) but we found it clashed with the following shifts:
      </p>
    </template>
    <template v-for="rota in message.data.clashes" :key="rota.id">
      <template v-if="isVolunteerClash">
        <h4
          class="link"
          @click="rotaClick(rota.id)"
          @keypress.enter="rotaClick(rota.id)"
        >
          <span v-if="rota.name">{{ rota.name }}: </span>
          {{ rota.type }} {{ rota.location }}
          <font-awesome-icon icon="external-link-alt" />
        </h4>
      </template>
      <template v-else>
        <h4 v-if="rota.id === message.data.rotaId">This rota</h4>
        <h4
          v-else
          class="link"
          @click="rotaClick(rota.id)"
          @keypress.enter="rotaClick(rota.id)"
        >
          <span v-if="rota.name">{{ rota.name }}: </span>
          {{ rota.type }} {{ rota.location }}
          <font-awesome-icon icon="external-link-alt" />
        </h4>
      </template>
      <ul class="mb-2">
        <li v-for="shift in rota.shifts" :key="shift.id">
          {{ formatDateAsDayWithSuffix(shift.startDate) }}
          {{ formatTimeHoursMins(shift.startDate) }} -
          {{ formatTimeHoursMins(shift.endDate) }}
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { computed } from "vue";
import { useRouter } from "vue-router";
import find from "lodash/find";
import {
  formatTimeHoursMins,
  formatDateAsDayWithSuffix,
} from "../../../lib/date-functions";

export default {
  name: "ToastShiftClashNotice",
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();

    // the assignee will always be the same person, so we can pick it from the first clash
    const assignee = computed(
      () =>
        find(props.message.data.clashes[0].shifts[0].assignedTo, {
          type: "current",
        }).displayName,
    );

    const isVolunteerClash = computed(() =>
      props.message.message.includes("volunteered"),
    );

    function rotaClick(rotaId) {
      const link = router.resolve({
        name: "rota/RotaView",
        params: { rotaId },
      });
      window.open(link.href, "_blank", "noopener,noreferrer");
    }

    return {
      assignee,
      formatTimeHoursMins,
      formatDateAsDayWithSuffix,
      rotaClick,
      isVolunteerClash,
    };
  },
};
</script>

<style lang="scss" scoped>
h4.link {
  cursor: pointer;
  font-size: 1.25rem;
  &:hover {
    text-decoration: underline;
  }
}
</style>
